import { render, staticRenderFns } from "./CssImg.vue?vue&type=template&id=0c0732c8&scoped=true&"
import script from "./CssImg.vue?vue&type=script&lang=js&"
export * from "./CssImg.vue?vue&type=script&lang=js&"
import style0 from "./CssImg.vue?vue&type=style&index=0&id=0c0732c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0732c8",
  null
  
)

export default component.exports